<svg width="18" height="12">
    <line x1="1" y1="11" x2="11" y2="1" stroke-width="3" stroke="#793507"/>
    <line x1="11" y1="11" x2="1" y2="1" stroke-width="3" stroke="#793507"/>
</svg>